export const translations = {
  en: {
    logout: "Logout",
    title: "System Settings",
    subtitle: "Manage your preferences and system configuration",
    appearance: {
      title: "Appearance & Theme",
      description: "Customize the visual appearance of your dashboard",
      themeMode: "Theme Mode",
      themeDescription: "Choose your preferred theme",
      light: "Light",
      dark: "Dark",
      fontSize: "Font Size",
      fontDescription: "Adjust text size for readability",
      animations: "Animations",
      animationsDescription: "Enable smooth transitions",
    },
    language: {
      title: "Language & Region",
      description: "Set your preferred language and regional settings",
      displayLanguage: "Display Language",
      languageDescription: "Choose your interface language",
      english: "English",
      arabic: "Arabic",
    },
    notifications: {
      title: "Notifications",
      description: "Control how and when you receive notifications",
      email: "Email Notifications",
      emailDescription: "Receive updates via email",
      push: "Push Notifications",
      pushDescription: "Browser push notifications",
      disableNotifications: "Disable Notifications",
      disableNotificationsDescription: "Hide all notification alerts",
    },
    miniChat: {
      title: "Mini Chat Bar",
      description: "Control the floating chat bar shown across all pages",
      showMiniChat: "Show Mini Chat Bar",
      showMiniChatDescription: "Display the floating chat dock on every page",
    },
    privacy: {
      title: "Privacy & Security",
      description: "Manage your privacy and security preferences",
      twoFactor: "Two-Factor Authentication",
      twoFactorDescription: "Add extra security",
      password: "Password Settings",
      lastChanged: "Last changed: 2 weeks ago",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm New Password",
      enterCurrentPassword: "Enter Current Password",
      enterNewPassword: "Enter New Password",
      enterConfirmPassword: "Enter Confirm Password",
      passwordMinLength: "Password must be at least 6 characters long",
      passwordsDoNotMatch: "New passwords do not match",
      allFieldsRequired: "All fields are required",
      savePasswordButton: "Save Password",
      passwordSuccessfullyChanged: "Password changed successfully",
    },
    advanced: {
      title: "Advanced Settings",
      description: "Advanced configuration and system management",
      export: "Export Settings",
      exportDescription: "Download your settings as JSON file",
      import: "Import Settings",
      importDescription: "Import configuration from backup",
      reset: "Reset to Default",
      resetDescription: "Restore all settings to default values",
      clearCache: "Clear Cache",
      cacheDescription: "Clear temporary files and cached data",
      help: "Help & Support",
      helpDescription: "Get help with settings and configuration",
      exportButton: "Export",
      importButton: "Import",
      resetButton: "Reset",
      clearButton: "Clear",
      helpButton: "Get Help",
    },
    fontSizes: {
      small: "Small",
      medium: "Medium",
      large: "Large",
    },
  },
  ar: {
    logout: "تسجيل الخروج",
    title: "إعدادات النظام",
    subtitle: "إدارة التفضيلات وتكوين النظام",
    appearance: {
      title: "المظهر والثيم",
      description: "تخصيص المظهر المرئي للوحة التحكم",
      themeMode: "وضع الثيم",
      themeDescription: "اختر الثيم المفضل لديك",
      light: "فاتح",
      dark: "داكن",
      fontSize: "حجم الخط",
      fontDescription: "ضبط حجم النص لسهولة القراءة",
      animations: "الحركات",
      animationsDescription: "تفعيل التحولات السلسة",
    },
    language: {
      title: "اللغة والمنطقة",
      description: "تعيين اللغة والإعدادات الإقليمية المفضلة",
      displayLanguage: "لغة العرض",
      languageDescription: "اختر لغة الواجهة",
      english: "الإنجليزية",
      arabic: "العربية",
    },
    notifications: {
      title: "الإشعارات",
      description: "التحكم في كيفية ووقت استلام الإشعارات",
      email: "إشعارات البريد الإلكتروني",
      emailDescription: "استقبال التحديثات عبر البريد",
      push: "الإشعارات الفورية",
      pushDescription: "إشعارات المتصفح الفورية",
      disableNotifications: "إلغاء الإشعارات",
      disableNotificationsDescription: "إخفاء جميع تنبيهات الإشعارات",
    },
    miniChat: {
      title: "شريط الشات المصغّر",
      description: "التحكم في شريط الشات العائم الظاهر في كل الصفحات",
      showMiniChat: "إظهار شريط الشات المصغّر",
      showMiniChatDescription: "عرض شريط المحادثات العائم في كل صفحة",
    },
    privacy: {
      title: "الخصوصية والأمان",
      description: "إدارة تفضيلات الخصوصية والأمان",
      twoFactor: "المصادقة الثنائية",
      twoFactorDescription: "إضافة أمان إضافي",
      password: "إعدادات كلمة المرور",
      lastChanged: "آخر تغيير: منذ أسبوعين",
      changePassword: "تغيير كلمة المرور",
      currentPassword: "كلمة المرور الحالية",
      newPassword: "كلمة المرور الجديدة",
      confirmPassword: "تأكيد كلمة المرور الجديدة",
      enterCurrentPassword: "ادخل كلمة المرور الحالية",
      enterNewPassword: "ادخل كلمة المرور الجديدة",
      enterConfirmPassword: "تأكيد كلمة المرور الجديدة",
      passwordMinLength: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      passwordsDoNotMatch: "كلمتا المرور الجديدتان غير متطابقتين",
      allFieldsRequired: "جميع الحقول مطلوبة",
      savePasswordButton: "حفظ كلمة المرور",
      passwordSuccessfullyChanged: "تم تغيير كلمة المرور بنجاح",
    },
    advanced: {
      title: "الإعدادات المتقدمة",
      description: "التكوين المتقدم وإدارة النظام",
      export: "تصدير الإعدادات",
      exportDescription: "تنزيل إعداداتك كملف JSON",
      import: "استيراد الإعدادات",
      importDescription: "استيراد التكوين من نسخة احتياطية",
      reset: "إعادة التعيين للافتراضي",
      resetDescription: "استعادة جميع الإعدادات للقيم الافتراضية",
      clearCache: "مسح ذاكرة التخزين المؤقت",
      cacheDescription: "مسح الملفات المؤقتة والبيانات المخزنة",
      help: "المساعدة والدعم",
      helpDescription: "الحصول على مساعدة في الإعدادات والتكوين",
      exportButton: "تصدير",
      importButton: "استيراد",
      resetButton: "إعادة تعيين",
      clearButton: "مسح",
      helpButton: "احصل على مساعدة",
    },
    fontSizes: {
      small: "صغير",
      medium: "متوسط",
      large: "كبير",
    },
  },
};